window.Edocat = window.Edocat || {};

if (process.env.NODE_ENV === 'production') {
  window.Edocat.versions = window.Edocat.versions || {};
  window.Edocat.versions.REACT_BASE = APP_VERSION;
}

if (!window.HashChangeEvent) {
  require('./Components/Router/utils/hashChangePolyfill');
}

// Config
if (window.Alfresco) {
  window.Edocat.Config.dateFormat =
    window.Alfresco.messages.global['edocat.override.js-config.date-format'] ||
    window.Alfresco.messages.global['edocat.js-config.date-format'];
  window.Edocat.Config.timeFormat =
    window.Alfresco.messages.global['edocat.override.js-config.time-format'] ||
    window.Alfresco.messages.global['edocat.js-config.time-format'];
  window.Edocat.Config.dateTimeFormat =
    window.Alfresco.messages.global['edocat.override.js-config.date-time-format'] ||
    window.Alfresco.messages.global['edocat.js-config.date-time-format'];
}

// Components
window.Edocat.Components = {};

window.React = require('react');
window.reactDOM = require('react-dom');
window.reactRedux = require('react-redux');
window.redux = require('redux');
window.reduxThunk = require('redux-thunk').default;

window.moment = require('moment');
window.EdocatUtils = require('./utils');

// Deprecated, do not use
window.EdocatUtils.FakeMoment = require('./Deprecated/utils/Fake').default;
window.EdocatUtils.injectDependencies = require('./Deprecated/utils/injectDependencies').default;

window.promiseMiddleware = require('redux-promise-middleware').default;
window.promisePolyfill = require('promise-polyfill');

// DEPRECATION: BASE 4.0 - remove Editor and Router from window.
window.Editor = require('./Deprecated/Editor').default;
window.ReactSelectExt = require('react-select');

window.Edocat.Components.Editor = require('./Components/Editor').default;
window.Edocat.Components.Button = require('./Components/Button').default;
window.Edocat.Components.Modal = require('./Components/Modal').default;
window.Edocat.Components.Router = require('./Components/Router');
window.Edocat.Components.Select = require('./Components/Select');
window.Edocat.Components.Preview = require('./Components/Preview').default;
window.Edocat.Components.Datepicker = require('./Components/Datepicker').default;

// DEPRECATION: BASE 4.0 - remove ReactDatePicker from window.
window.ReactDatePicker = require('./Deprecated/Datepicker').default;
window.ReactHelmet = require('react-helmet');
window.ReactPagination = require('react-paginate').default;
// DEPRECATION: BASE 4.0 - remove Editor and Router from window.
window.Router = require('./Deprecated/Router');
window.ReactPaginate = require('./Deprecated/reactPaginateDeprecated');
window.ReactModal = require('./Deprecated/reactModalDeprecated').default;
// React Autosuggest was removed completely, use Components/Select/Authority instead
window.ReactAutoSuggest = require('./Deprecated/reactAutoSuggestDeprecated').default;

window.Switcher = require('rc-switch').default;

// fallback for react-select 2.0 -- Proxy Component
// DEPRECATION: BASE 4.0 - remove Editor and Router from window.
window.ReactSelect = require('./Deprecated/Select');

import '../node_modules/react-datepicker/dist/react-datepicker.css';
import '../node_modules/rc-switch/assets/index.css';
import './Styles/Global.scss';
